const initialState = {
  loggedin: false,
  user: null,
  token: null,
  sidebar: false,
  loading: true,
  additional_details: false,
  deposit_opened: false,
  balance_tab: 0,
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case "TOGGLE_SIDEBAR":
      return {
        ...state,
        sidebar: !state.sidebar,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
        loggedin: true,
      };
    case "SET_TOKEN":
      return {
        ...state,
        token: action.payload,
      };
    case "UPDATE_PROFILE":
      return {
        ...state,
        user: {
          ...state.user,
          profile: action.payload,
        },
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        loggedin: false,
        token: null,
      };
    case "CHECK_ADDITIONAL_DETAILS":
      return {
        ...state,
        additional_details: action.payload
      }
    case "TOGGLE_DEPOSIT_MODAL":
      return {
        ...state,
        deposit_opened: action.payload.is_opened,
        balance_tab: action.payload.tab
      }
    default:
      return state;
  }
}
